import SettingsRoundedIcon from "@mui/icons-material/SettingsRounded";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import HelpRoundedIcon from "@mui/icons-material/HelpRounded";
import HomeRoundedIcon from "@mui/icons-material/HomeRounded";
import AnalyticsRoundedIcon from "@mui/icons-material/AnalyticsRounded";
import PeopleRoundedIcon from "@mui/icons-material/PeopleRounded";
import AssignmentRoundedIcon from "@mui/icons-material/AssignmentRounded";
import { CasinoRounded, PostAddRounded } from "@mui/icons-material";

export const customerMenuItems = [
  { text: "Home", icon: <HomeRoundedIcon />, to: "/customer/dashboard" },
  { text: "My Agenda", icon: <AssignmentRoundedIcon />, to: "/customer/agenda" },
];

// You can remove it or add more options, these will be shared with the users
export const secondaryListItemsDashboard = [
  { text: "Settings", icon: <SettingsRoundedIcon /> },
  { text: "About", icon: <InfoRoundedIcon /> },
  { text: "Feedback", icon: <HelpRoundedIcon /> },
];

// admin menu items
export const adminMenuItems = [
  { text: "Home", icon: <HomeRoundedIcon />, to: "/dashboard" },
  { text: "Analytics", icon: <AnalyticsRoundedIcon />, to: "#" },
  { text: "Employees", icon: <PeopleRoundedIcon />, to: "/dashboard/users" },
  {
    text: "Gym Users",
    icon: <PeopleRoundedIcon />,
    to: "/dashboard/gym-users",
  },

  {
    text: "Tickets",
    icon: <AssignmentRoundedIcon />,
    to: "/dashboard/tickets",
  },
  { text: "Blog", icon: <PostAddRounded />, to: "/dashboard/blog" },
  { text: "Disputes", icon: <CasinoRounded />, to: "/dashboard/disputes" },
  { text: "Inventory", icon: <CasinoRounded />, to: "/dashboard/inventory" },
  { text: "Classes", icon: <CasinoRounded />, to: "/dashboard/classes" },
  { text: "Assets", icon: <CasinoRounded />, to: "/dashboard/assets" },
  { text: "Catalog", icon: <CasinoRounded />, to: "/dashboard/catalog" },
  { text: "Sales", icon: <CasinoRounded />, to: "/dashboard/sales" },
  { text: "Access", icon: <CasinoRounded />, to: "/dashboard/access" },
  { text: "Training", icon: <CasinoRounded />, to: "/dashboard/training" },
  { text: "Agenda", icon: <AssignmentRoundedIcon />, to: "/dashboard/agenda" },
  { text: "Agenda Settings", icon: <SettingsRoundedIcon />, to: "/dashboard/agenda/settings" },
  { text: "Contracts", icon: <CasinoRounded />, to: "/dashboard/contracts" },
];
